<template>
  <div class="elite-tabs-wrapper-content">
    <log-list-table :filterSubject="dpaAccount" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "dpa-account-view-logs",

  components: { LogListTable },

  props: ["dpaAccount"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
